import { render, staticRenderFns } from "./ParamDetails.vue?vue&type=template&id=0440166b"
import script from "./ParamDetails.vue?vue&type=script&lang=js"
export * from "./ParamDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports